import { module } from 'modujs';
const axios = require('axios').default;
import isEmail from 'is-email';


export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'submit', this.onSubmit.bind( this ) );

        this.responseAreaMsg = this.$('response-msg-area')[0];
        this.responseAreaMsgSuccess = this.$('response-msg-success')[0];
        this.responseAreaMsgError = this.$('response-msg-error')[0];
        this.checkbox = this.$('checkbox')[0];
        this.checkbox2 = this.$('checkbox2')[0];
        this.emailInput = this.$('email-input')[0];
        this.emailButton = this.$('email-button')[0];
        this.events();
    }


    onSubmit( ev ){

        ev.preventDefault();

        this.clearMessages();

        if( ! this.validateForm() ) return;

        this.emailButton.classList.add( 'loading' );

        axios.post(window.location.href, new FormData( this.el ) ).then( (response) => {
            let message =  Object.values(response.data.messages)[0];
            if( response.data.success === true ){
                this.responseAreaMsgSuccess.innerHTML = message;
                this.responseAreaMsgSuccess.classList.remove( 'opacity-0' );
            } else {
                this.responseAreaMsgError.innerHTML = message;
                this.responseAreaMsgError.classList.remove( 'opacity-0' );
            }

            this.emailButton.classList.remove( 'loading' );

            // setTimeout(() => this.clearMessages() , 5000);

        }).catch(function (error) {
        });
    }

    clearMessages(){
        this.responseAreaMsgSuccess.innerHTML = '';
        this.responseAreaMsgSuccess.classList.add( 'opacity-0' );

        this.responseAreaMsgError.innerHTML = '';
        this.responseAreaMsgError.classList.add( 'opacity-0' );
    }

    validateForm(){
        if( ! isEmail( this.emailInput.value ) ){
            this.responseAreaMsgError.innerHTML = FORM_MESSAGES.emailRequired;
            this.responseAreaMsgError.classList.remove( 'opacity-0' );
            return false;
        }

        if( ! this.checkbox.checked ){
            this.responseAreaMsgError.innerHTML = FORM_MESSAGES.acceptPolicy;
            this.responseAreaMsgError.classList.remove( 'opacity-0' );
            return false;
        }

        if( ! this.checkbox2.checked ){
            this.responseAreaMsgError.innerHTML = FORM_MESSAGES.acceptTerms;
            this.responseAreaMsgError.classList.remove( 'opacity-0' );
            return false;
        }

        return true;
    }

    events(){
        this.checkbox.addEventListener( 'input', () => this.clearMessages() );
        this.checkbox2.addEventListener( 'input', () => this.clearMessages() );
        this.emailInput.addEventListener( 'input', () => this.clearMessages() );
    }

    init() {}
    destroy(){}
}
